import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// @mui/material components
import Grid from "@mui/material/Grid";

const gridSx = {
  marginRight: "-15px",
  marginLeft: "-15px",
  width: "auto"
};

export default function GridContainer(props) {
  const { children, className, ...rest } = props;
  return (
    <Grid container {...rest} sx={gridSx} className={className}>
      {children}
    </Grid>
  );
}

GridContainer.defaultProps = {
  className: ""
};

GridContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
